// extracted by mini-css-extract-plugin
module.exports = {"EasyUse":"EasyUse_EasyUse__HIyl8"};